import type { Control } from 'react-hook-form';

import type { SanityDefaultForm } from '#/lib/sanity/queries/form';
import { cn } from '#/lib/utils';
import { CountryRegionSelector } from '#/components/CountryRegionSelector';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../FormControls';
import { getFormFieldComponent } from '../utils';

export function FormFields(props: {
  autoFocusFirstField?: boolean;
  fields: SanityDefaultForm['fields'];
  control: Control<any>;
  theme?: 'light' | 'dark';
}) {
  return (
    <>
      {props.fields.map((fieldData, index) => {
        if (fieldData._type === 'countryRegion') {
          return (
            <CountryRegionSelector
              key={fieldData._key}
              label={fieldData.label}
              theme={props.theme}
            />
          );
        } else {
          return (
            <FormField
              key={fieldData._key}
              name={fieldData.name}
              control={props.control}
              defaultValue={''}
              render={({ field: fieldProps }) => {
                return (
                  <FormItem
                    className={cn('col-span-full', {
                      'l:col-span-1':
                        'isHalfWidthOnDesktop' in fieldData &&
                        fieldData.isHalfWidthOnDesktop,
                    })}
                  >
                    <FormLabel className="sr-only">{fieldData.label}</FormLabel>
                    <FormControl>
                      {getFormFieldComponent(
                        fieldData,
                        fieldProps,
                        props.autoFocusFirstField && index === 0,
                        props.theme,
                      )}
                    </FormControl>
                    <FormDescription />
                    <FormMessage className="legal-text mt-4 text-flame-06" />
                  </FormItem>
                );
              }}
            />
          );
        }
      })}
    </>
  );
}
